import React from 'react';
import {Checkbox, Drawer, Grid, Table, TableBody, TableCell, TableHead, TableRow, withStyles} from "material-ui";
import {connect} from "react-redux";
import {closeTaskFilterDrawer} from "../../../redux/actions/drawer";
import {setFilterTask} from "../../../redux/actions/filter";

export class TaskFilterDrawer extends React.Component {

    state = {
        status: [false, false],
    };

    componentDidMount = () => {
        this.setState({status: this.props.filter.status});
    };

    handleCheckBox = (index) => {
        let _filter = this.props.filter;
        _filter.status[index] = !this.props.filter.status[index];
        this.setState({status: _filter.status});
        this.props.setFilterTask(_filter);
    };

    handleClose = () => {
        this.props.closeTaskFilterDrawer();
        this.props.handleClose();
    };

    render() {

        const {classes, isOpen} = this.props;
        const {status} = this.state;

        const statuses = ['オープン', '終了'];

        return (
            <Drawer
                anchor="right"
                open={isOpen}
                onClose={this.handleClose}>
                <div className={classes.root}>
                    <Table className={classes.table}>
                        <TableHead>
                            <TableRow>
                                <TableCell>フィルター</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>

                            {statuses.map((n, i) => {
                                return <TableRow key={i}>
                                    <TableCell>
                                        <Grid container alignItems="center">
                                            <Grid item>
                                                <Checkbox
                                                    onClick={this.handleCheckBox.bind(this, i)}
                                                    checked={status[i]}/>
                                            </Grid>
                                            <Grid item>{n}</Grid>
                                        </Grid>
                                    </TableCell>
                                </TableRow>
                            })}

                        </TableBody>
                    </Table>
                </div>
            </Drawer>
        )
    }
}

const styles = theme => ({
    root: {
        width: 300,
    },
    clickRow: {
        cursor: 'pointer',
    },
});

TaskFilterDrawer = withStyles(styles)(TaskFilterDrawer);

TaskFilterDrawer = connect(
    (state) => {
        return {
            isOpen: state.drawer.isOpenTaskFilterDrawer,
            filter: state.filter.task,
        }
    },
    (dispatch) => {
        return {
            closeTaskFilterDrawer: () => {
                dispatch(closeTaskFilterDrawer());
            },
            setFilterTask: (filter) => {
                dispatch(setFilterTask(filter));
            },
        }
    }
)(TaskFilterDrawer);


// WEBPACK FOOTER //
// ./src/containers/task/drawer/filter.js